import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { personalizedJourneyTypeEntryPoint } from '@atlassian/jira-spa-apps-servicedesk-journeys/personalizedJourneyTypeEntryPoint.tsx';

export const personalizedJourneyType: ReturnType<typeof createPageEntryPoint> =
	createPageEntryPoint({
		main: personalizedJourneyTypeEntryPoint,
		topNavigationMenuId: MENU_ID.PROJECTS,
	});
